"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UNIVERSE_API_URLS = void 0;
var UNIVERSE_API_URLS;
(function (UNIVERSE_API_URLS) {
    UNIVERSE_API_URLS["GET_INFO"] = "/v2/universe/info";
    UNIVERSE_API_URLS["GET_MINE"] = "/v2/universe/get-mine";
    UNIVERSE_API_URLS["CREATE"] = "/v2/universe/create";
    UNIVERSE_API_URLS["SET_UI_SETTINGS"] = "/v2/universe/set-ui-settings";
    UNIVERSE_API_URLS["SET_UI_CONFIGURATION"] = "/v2/universe/set-ui-configuration";
    UNIVERSE_API_URLS["GET_UI_CONFIGURATION"] = "/v2/universe/get-ui-configuration";
    UNIVERSE_API_URLS["GET_ALL"] = "/v2/universe/get-all";
    UNIVERSE_API_URLS["GET_BY_FILTER"] = "/v2/universe/get-by-filter";
    UNIVERSE_API_URLS["VALIDATE_UNIQUENESS_DOMAIN"] = "/v2/universe/validate-domain-uniqueness";
    UNIVERSE_API_URLS["VALIDATE_UNIQUENESS_NAME"] = "/v2/universe/validate-name-uniqueness";
    UNIVERSE_API_URLS["SET_AFFILIATE"] = "/v2/universe/update_affiliate";
})(UNIVERSE_API_URLS = exports.UNIVERSE_API_URLS || (exports.UNIVERSE_API_URLS = {}));
